import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as scenarios from './scenarios';
import { SCENARIO_SKIP, SCENARIO_STOP, SCENARIO_USE } from './scenarios/constants';

var checkScenarios = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(scenarioUse, webapiUrl, headers, additionalData) {
    var scenarioList, skipResolve, checkedScenarios;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scenarioList = ['base'].concat(_toConsumableArray(scenarioUse));
            skipResolve = {
              status: SCENARIO_SKIP
            };
            _context2.next = 4;
            return scenarioList.reduce( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(previousResult, item) {
                var scenario, result;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        // eslint-disable-next-line import/namespace
                        scenario = scenarios[item];
                        _context.next = 3;
                        return previousResult;

                      case 3:
                        result = _context.sent;

                        if (!(result.status === SCENARIO_SKIP && scenario)) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 7;
                        return scenario(webapiUrl, headers, additionalData);

                      case 7:
                        return _context.abrupt("return", _context.sent);

                      case 8:
                        if (!(result.status === SCENARIO_STOP && item === 'inactive' && scenario)) {
                          _context.next = 12;
                          break;
                        }

                        _context.next = 11;
                        return scenario(webapiUrl, headers, additionalData);

                      case 11:
                        return _context.abrupt("return", _context.sent);

                      case 12:
                        return _context.abrupt("return", result);

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x5, _x6) {
                return _ref2.apply(this, arguments);
              };
            }(), Promise.resolve(skipResolve));

          case 4:
            checkedScenarios = _context2.sent;

            if (!(checkedScenarios.status === SCENARIO_USE && checkedScenarios.scenario)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", checkedScenarios.scenario);

          case 7:
            return _context2.abrupt("return", null);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function checkScenarios(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

export default checkScenarios;